import React from 'react'
import ContactFormSecureSite, {
  type ContactFormSecureSiteContent
} from './ContactFormSecureSite'
import ContactFormBrokerage, {
  type ContactFormBrokerageContent
} from './ContactFormBrokerage'
import ContactFormNFLPA, {
  type ContactFormNFLPAContent
} from './ContactFormNFLPA'
import ContactFormCCPA, { type ContactFormCCPAContent } from './ContactFormCCPA'
import ContactFormIRA, { ContactFormIRAContent } from './ContactFormIRA'
import ContactFormAPRI, { type ContactFormAPRIContent } from './ContactFormAPRI'
import ContactFormProfessionalAlliance, {
  type ContactFormProfessionalAllianceContent
} from './ContactFormProfessionalAlliance'
import ContactFormWorkplaceFinancialWellness, {
  type ContactFormWorkplaceFinancialWellnessContent
} from './ContactFormWorkplaceFinancialWellness'
import { sendEmail, CONSTs } from '../views/utils'
import 'whatwg-fetch'

export type FormTemplate = {
  name: string
}

export type FormProps = {
  formTemplate?: FormTemplate
  [key: string]: unknown
}

type EmailInfo = Record<string, unknown> & {
  emailApi?: string
  toEmailAddress?: string
  subject?: string
  fromEmailAddress?: string
  fromAddress?: string
  toAddress?: string
}

type FormData = Record<string, unknown> & {
  Email?: string
  ChangeFromAddress?: boolean
  'Client ID'?: string
}

const Form = (props: FormProps) => {
  const { formTemplate } = props

  const sendEmailToService = (
    items: unknown,
    emailInfoArg: unknown,
    reverseCallback: (props: unknown, message?: string) => void,
    showEmailIntro = false
  ): void => {
    const data = items as FormData
    const emailInfo = emailInfoArg as EmailInfo
    emailInfo.fromAddress = data.Email as string | undefined
    if (
      typeof data.ChangeFromAddress !== 'undefined' &&
      data.ChangeFromAddress === true
    ) {
      emailInfo.fromAddress = emailInfo.fromEmailAddress as string | undefined
      delete data.ChangeFromAddress
    }
    if (typeof data['Client ID'] !== 'undefined' && data['Client ID'] === '') {
      delete data['Client ID']
    }
    const formEntries = Object.entries(data)
      .map(entry => entry.join(': ') + '<br />')
      .join('')
    const emailContent =
      showEmailIntro && emailInfo.emailIntro
        ? `${emailInfo.emailIntro} ${formEntries}`
        : formEntries
    emailInfo.toAddress = emailInfo.toEmailAddress as string | undefined
    sendEmail(emailContent, emailInfo, reverseCallback)
  }

  const renderTemplate = () => {
    if (formTemplate && formTemplate.name) {
      switch (formTemplate.name) {
      case CONSTs.CONTACTSECURESITE:
        return (
          <ContactFormSecureSite
            content={props as unknown as ContactFormSecureSiteContent}
            name={CONSTs.CONTACTSECURESITE}
            callback={sendEmailToService}
          />
        )
      case CONSTs.CONTACTBROKERAGE:
        return (
          <ContactFormBrokerage
            content={props as unknown as ContactFormBrokerageContent}
            name={CONSTs.CONTACTBROKERAGE}
            callback={sendEmailToService}
          />
        )
      case CONSTs.CONTACTNFLPA:
        return (
          <ContactFormNFLPA
            content={props as unknown as ContactFormNFLPAContent}
            name={CONSTs.CONTACTNFLPA}
            callback={sendEmailToService}
          />
        )
      case CONSTs.CONTACTCCPA:
        return (
          <ContactFormCCPA
            content={props as unknown as ContactFormCCPAContent}
            name={CONSTs.CONTACTCCPA}
            callback={sendEmailToService}
          />
        )
      case CONSTs.CONTACTIRA:
        return (
          <ContactFormIRA
            content={props as unknown as ContactFormIRAContent}
            name={CONSTs.CONTACTIRA}
            callback={sendEmailToService}
          />
        )
      case CONSTs.CONTACTAPRI:
        return (
          <ContactFormAPRI
            content={props as unknown as ContactFormAPRIContent}
            name={CONSTs.CONTACTAPRI}
            callback={sendEmailToService}
          />
        )
      case CONSTs.PROFESSIONALALLIANCE:
        return (
          <ContactFormProfessionalAlliance
            content={
                props as unknown as ContactFormProfessionalAllianceContent
            }
            name={CONSTs.PROFESSIONALALLIANCE}
            callback={sendEmailToService}
          />
        )
      case CONSTs.CONTACTWORKPLACEFINANCIALWELLNESS:
        return (
          <ContactFormWorkplaceFinancialWellness
            content={
                props as unknown as ContactFormWorkplaceFinancialWellnessContent
            }
            name={CONSTs.CONTACTWORKPLACEFINANCIALWELLNESS}
            callback={sendEmailToService}
          />
        )
      default:
        return null
      }
    }
    return null
  }

  return <div>{renderTemplate()}</div>
}

export default Form
